import ExternalTitleCardFormatter from 'crm-cards-sdk/card-formatters/ExternalTitleCardFormatter';
import GridCardFormatter from 'crm-cards-sdk/card-formatters/GridCardFormatter';
import { CardContainerContextProvider } from 'crm-cards-sdk/internal/CardContainerContext';
import { useMemo } from 'react';
import CollapsibleCardFormatterWithAPI from '../internal/cardFormatterDecorators/CollapsibleCardFormatterWithAPI';
import { createContainerContentKey } from './createContainerContentKey';
import { Grid, GridItem } from 'foundations-components/transitional/components/Grid';
// default to half width
import { jsx as _jsx } from "react/jsx-runtime";
const DEFAULT_GRID_ITEM_SIZE = 6;
const getGridItemSize = gridItem => {
  var _gridItem$layout, _gridItem$layout2;
  if ((_gridItem$layout = gridItem.layout) !== null && _gridItem$layout !== void 0 && _gridItem$layout.widthInGrid) {
    return gridItem.layout.widthInGrid;
  }

  // This is legacy behavior, the inParent should be going away.
  if (gridItem.type === 'CONTAINER' && (_gridItem$layout2 = gridItem.layout) !== null && _gridItem$layout2 !== void 0 && (_gridItem$layout2 = _gridItem$layout2.inParent) !== null && _gridItem$layout2 !== void 0 && _gridItem$layout2.gridItemSize) {
    return gridItem.layout.inParent.gridItemSize;
  }
  return DEFAULT_GRID_ITEM_SIZE;
};
export default function UIGridContainerFormatter({
  containerId,
  contents,
  CrmContainerContentRenderer,
  observerManager,
  layout,
  CardFormatter
}) {
  const DefaultCardFormatter = useMemo(() => {
    if (CardFormatter) {
      return CardFormatter;
    }
    if (layout.use === 'collapsible-cards') {
      return CollapsibleCardFormatterWithAPI;
    }
    if (layout.use === 'external-title') {
      return ExternalTitleCardFormatter;
    }
    return GridCardFormatter;
  }, [CardFormatter, layout.use]);
  return /*#__PURE__*/_jsx(CardContainerContextProvider, {
    value: {
      DefaultCardFormatter,
      reorderable: false,
      observerManager
    },
    children: /*#__PURE__*/_jsx(Grid, {
      marginInlineStart: "0",
      marginInlineEnd: "0",
      children: contents.map(gridItem => {
        return /*#__PURE__*/_jsx(GridItem, {
          size: getGridItemSize(gridItem),
          paddingInline: "200",
          paddingBlockEnd: "400",
          children: /*#__PURE__*/_jsx(CrmContainerContentRenderer, {
            content: gridItem
          })
        }, createContainerContentKey(containerId, gridItem));
      })
    })
  });
}